import React from "react";
import CardGroup from "../modules/layout/CardGroup";

const contents = [
  {
    title: "조용하고 밝은 환경에서 답변",
    component: (
      <>
        원활한 평가녹화를 위해서
        <br />
        조용하고 다른 사람의 방해를
        <br />
        받지 않으며, 조명이 환한 장소에서
        <br />
        면접에 응시하는 것이 좋습니다.
        <br />
        이어폰(마이크기능 탑재)을 꼭 사용해주세요.
      </>
    ),
  },
  {
    title: "카메라의 정면 응시",
    component: (
      <>
        단정한 옷차림으로
        <br />
        평가에 임하는 것이 좋습니다.
        <br />
        답변시 실제 평가자의 눈을 보고
        <br />
        응답하듯이 카메라의 정면을
        <br />
        응시하며 평가에 임하세요.
      </>
    ),
  },
  {
    title: "응답시간 준수",
    component: (
      <>
        문항을 잘 보고 응답 준비시간 동안
        <br />
        답변을 준비합니다.
        <br />
        이후 녹화가 시작되면
        <br />
        주어진 녹화시간 안에
        <br />
        응답을 완료해주시기 바랍니다.
      </>
    ),
  },
];

const GuideCardGroup = () => {
  return <CardGroup contents={contents} />;
};

export default GuideCardGroup;
